import { Component } from '@angular/core';

@Component({
    selector: 'marketplace-pending-approval',
    templateUrl: './pending-approval.component.html',
    styleUrls: ['./pending-approval.component.scss'],
    standalone: false
})
export class PendingApprovalComponent {}
